import { render, staticRenderFns } from "./VariableDisplayText.vue?vue&type=template&id=a220bd2a&"
import script from "./VariableDisplayText.vue?vue&type=script&lang=ts&"
export * from "./VariableDisplayText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports